import { useCallback, useEffect, useState } from "react";
import storage from "../../utils/storage";

const VALID = new Set(["list-1", "list-2", "grid-3", "grid-4"]);

/**
 * Liste sayfası view mode persistence — `pms_view_mode_<scopeKey>`
 * localStorage anahtarı altında saklanır; sayfa yenilemede korunur.
 *
 *   const [view, setView] = useViewMode("tasks", "list-1");
 */
const useViewMode = (scopeKey, defaultValue = "list-1") => {
  const storageKey = `view_mode_${scopeKey}`;

  const [view, setView] = useState(() => {
    const stored = storage.get(storageKey);
    return stored && VALID.has(stored) ? stored : defaultValue;
  });

  const update = useCallback(
    (next) => {
      if (!VALID.has(next)) return;
      setView(next);
      storage.set(storageKey, next);
    },
    [storageKey]
  );

  useEffect(() => {
    // Default değer storage'da yoksa sessizce yazılır (idempotent).
    if (!storage.get(storageKey)) storage.set(storageKey, view);
  }, [storageKey, view]);

  return [view, update];
};

export default useViewMode;
